import styled from "styled-components";
import { Input } from "../../../../../components/Input/input";
import { theme } from "../../../../../helpers/theme";

interface CustomerDataProps {
  formik: any;
}

const CustomerData = ({ formik }: CustomerDataProps) => {
  return (
    <CustomerDataContainer>
      <CustomerDataHeader>Dane klienta</CustomerDataHeader>
      <CustomerDataInputsWrapper>
        <Input
          label="Nazwa firmy:"
          id="companyName"
          name="companyName"
          value={formik.values.companyName}
          onChange={formik.handleChange}
          error={
            formik.touched.companyName && Boolean(formik.errors.companyName)
          }
          helperText={formik.touched.companyName && formik.errors.companyName}
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
            width: "295px",
          }}
        />
        <Input
          label="NIP:"
          id="companyNip"
          name="companyNip"
          value={formik.values.companyNip}
          onChange={formik.handleChange}
          error={formik.touched.companyNip && Boolean(formik.errors.companyNip)}
          helperText={formik.touched.companyNip && formik.errors.companyNip}
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
            width: "295px",
          }}
        />
        <Input
          label="Telefon"
          id="customerPhone"
          name="customerPhone"
          type="phone"
          value={formik.values.customerPhone}
          onChange={formik.handleChange}
          error={
            formik.touched.customerPhone && Boolean(formik.errors.customerPhone)
          }
          helperText={
            formik.touched.customerPhone && formik.errors.customerPhone
          }
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
            width: "295px",
          }}
        />
        <Input
          label="E-mail"
          id="customerEmail"
          name="customerEmail"
          value={formik.values.customerEmail}
          onChange={formik.handleChange}
          error={
            formik.touched.customerEmail && Boolean(formik.errors.customerEmail)
          }
          helperText={
            formik.touched.customerEmail && formik.errors.customerEmail
          }
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
            width: "295px",
          }}
        />
      </CustomerDataInputsWrapper>
    </CustomerDataContainer>
  );
};

export default CustomerData;
const CustomerDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const CustomerDataHeader = styled.h3`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: black;
  margin-bottom: 16px;
  margin-left: 4px;
`;
const CustomerDataInputsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
`;
